import { NextParsedUrlQuery } from "next/dist/server/request-meta";
import { Product, Variant } from "../../types/types";

export function createSelectedColourUrlObj(
  selectedColour: string,
  product: Product,
  query: NextParsedUrlQuery,
) {
  const variants: Variant[] = product.variants;

  const targetVariant = variants.find(
    (v) => v.differentiators?.colour === selectedColour,
  );

  const queryParams = Object.entries(query).reduce((acc, [key, val]) => {
    return key === "path" || !val ? acc : { ...acc, [key]: val };
  }, {});

  const url = targetVariant ? targetVariant.canonicalURL : product.canonicalURL;

  return { pathname: url, query: { ...queryParams } };
}
